<template>
  <div id="layout">
    <Navbar v-if="showNav" />
    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import Navbar from '@/components/Navbar.vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const { profile } = storeToRefs(userStore)

const showNav = computed(() => !!profile.value && !!profile.value.uid)
</script>
